import { StellarToml } from "@stellar/stellar-sdk";

// Check if EBIORO API is using HTTP (for development with localhost)
const ebioroApiUrl = import.meta.env.VITE_EBIORO_API || '';
const isHttpApi = ebioroApiUrl.startsWith('http://') || ebioroApiUrl.includes('localhost');

export async function stellarTolmResolver(homedomain:string):Promise<[any,{[key: string]: any}|any]>{

    try {

        const options = isHttpApi ? { allowHttp: true } : {};
        const toml = await StellarToml.Resolver.resolve(homedomain, options);
    
        return [null,toml]
        
    } catch (error) {
        
        return [error,null]
        
    }
    




}